recommendedTotal